import { Pipe, PipeTransform } from '@angular/core';
import { EmaFirmUserDto } from '../../interfaces/ema-firm-user-dto';
import { OrganizationUserDto } from '../../interfaces/organization-user-dto';
import { SsoUserDetailsDto } from '../../interfaces/sso-user-details-dto';

@Pipe({
    name: 'lastAndFirstName',
    standalone: true
})
export class LastAndFirstNamePipe implements PipeTransform {
    transform(user: Partial<EmaFirmUserDto> | Partial<OrganizationUserDto> | Partial<SsoUserDetailsDto>): string {
        if (!user) {
            return '';
        }
        const name = `${user.lastName ?? ''}, ${user.firstName ?? ''}`;
        return name;
    }
}
